const SOLICITACOES_ATUALIZADAS = 'turmas:solicitacoes-atualizadas'

export function notificarSolicitacoesDeTurmaAtualizadas(): void {
  window.dispatchEvent(new Event(SOLICITACOES_ATUALIZADAS))
}

export function ouvirSolicitacoesDeTurmaAtualizadas(listener: () => void): () => void {
  window.addEventListener(SOLICITACOES_ATUALIZADAS, listener)
  return () => window.removeEventListener(SOLICITACOES_ATUALIZADAS, listener)
}
